import { useFormContext } from 'react-hook-form';
import Grid from '@mui/material/Grid';

import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormInputTime } from '../../../components/hook-form/form-input.time.component';
import { servicesApiKeyStore } from '../../../api/masters/services-api-key-store';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { skillSetApiKeyStore } from '../../../api/masters/skill-set-api-key-store';
import { equipmentApiKeyStore } from '../../../api/masters/equipment-api-key-store';
import { serviceGroupApiKeyStore } from '../../../api/masters/service-group-api-key-store';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { serviceCategoryApiKeyStore } from '../../../api/masters/service-category-api-key-store';
import { FormCurrencyInput } from '../../../components/hook-form/form-currency-input.component';

export const ServiceMunicipalityForm = () => {
  const { setValue, getValues } = useFormContext();
  const serviceId = getValues('serviceID');
  const { data, isLoading } = useLoadData<ApiResponse<any>>(servicesApiKeyStore.getService(serviceId));

  setValue('serviceSkillsets', data?.data?.serviceSkillsets);
  setValue('serviceEquipments', data?.data?.serviceEquipments);
  setValue('serviceMarketAreas', data?.data?.serviceMarketAreas);
  const applicableOptions = [
    {
      value: true,
      label: 'Yes',
      isDefault: false,
    },
    {
      value: false,
      label: 'No',
      isDefault: true,
    },
  ];
  const planReviewOption = [
    {
      value: true,
      label: 'Yes',
      isDefault: false,
    },
    {
      value: false,
      label: 'No',
      isDefault: true,
    },
  ];
  const inspectionRequiredOption = [
    {
      value: true,
      label: 'Yes',
      isDefault: false,
    },
    {
      value: false,
      label: 'No',
      isDefault: true,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="Service Name" name="serviceName" maxLength={150} autoFocus disabled />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="Service Municipality Code" name="serviceCode" maxLength={150} />
      </Grid>
      {/* <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Description" name="description" maxLength={150} multiline={true} disabled />
      </Grid> */}
      {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="serviceGroupID"
          label="Service Group"
          getQueryKeyConfig={() => serviceGroupApiKeyStore.getServiceGroups()}
          optionsValueKey="serviceGroupID"
          optionsLabelKeys={['serviceGroupName']}
          disabled
        />
      </Grid> */}
      {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="serviceTypeID"
          label="Service Type"
          required
          getQueryKeyConfig={() => servicesApiKeyStore.getServiceTypes()}
          optionsValueKey="serviceTypeID"
          optionsLabelKeys={['serviceTypeName']}
          disabled
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="serviceCategoryID"
          label="Service Category"
          getQueryKeyConfig={() => serviceCategoryApiKeyStore.getServiceCategories()}
          optionsValueKey="serviceCategoryID"
          optionsLabelKeys={['serviceCategoryName']}
          disabled
        />
      </Grid> */}
      {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormCurrencyInput label="Service Base Price ($)" name="price" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormAutoCompleteMultiSelectDynamic
          name="serviceSkillsets"
          label="Required Skills"
          getQueryKeyConfig={() => skillSetApiKeyStore.getSkillSets()}
          optionsLabelKey="skillsetName"
          optionsValueKey="skillsetID"
          disabled
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormAutoCompleteMultiSelectDynamic
          name="serviceEquipments"
          label="Required Equipments"
          getQueryKeyConfig={() => equipmentApiKeyStore.getEquipments()}
          optionsLabelKey="equipmentName"
          optionsValueKey="equipmentID"
          disabled
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="predecessorServiceID"
          label="Predecessor"
          getQueryKeyConfig={() => servicesApiKeyStore.getServices()}
          optionsValueKey="serviceID"
          optionsLabelKeys={['serviceName']}
          disabled
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="billingTypeID"
          label="Billing Type"
          getQueryKeyConfig={() => servicesApiKeyStore.getServiceBillingTypes()}
          optionsValueKey="billingTypeID"
          optionsLabelKeys={['billingType']}
          disabled
        />
      </Grid> */}
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInputTime name="cutOffTime" label="Cut-off Time" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelect label="Inspection Required " name="isInspectionRequired" options={inspectionRequiredOption} />
      </Grid>
      {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelect name="isPassFailedApplicable" label="Pass/Fail Applicable" options={applicableOptions} disabled />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelectDynamic
          name="retestServiceID"
          label="Retest Service"
          getQueryKeyConfig={() => servicesApiKeyStore.getServices()}
          optionsValueKey="serviceID"
          optionsLabelKeys={['serviceName']}
          disabled
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelect label="Plan Review" name="isPlanReviewRequired" options={planReviewOption} disabled />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="FastField FormID" name="fastFieldFormID" disabled />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
          <FormCheckbox label="Auto Retest on Failure" name="autoRetestOnFailure" disabled />
          <FormCheckbox label="DUX Service" name="isDuxService" disabled />
          <FormCheckbox label="Active" name="isActive" disabled />
        </Grid>
      </Grid> */}
    </Grid>
  );
};
